// extracted by mini-css-extract-plugin
module.exports = {"container":"faqs-module--container--3X1sP","title":"faqs-module--title--_aMNm"};